import React from "react";
import { useTranslation } from "react-i18next";
import { ErrorLabelStyle } from "../style";
import { StyledInput, StyledInputContent, StyledLabel } from "./style";
import { cn } from "../../../utils/classNames";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  params?: any;
  error?: any;
  text?: string;
  count?: any;
  disabled?: boolean;
  className?: string;
  icon?: React.ReactElement;
}

const CustomInput = ({
  label,
  text,
  count,
  params,
  disabled = false,
  error = false,
  className = "",
  icon,
  ...props
}: InputProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn("mb-3", className)}>
      {label && (
        <StyledLabel>
          {label}
          {icon ? <div className="info_icon">{icon}</div> : ""}
        </StyledLabel>
      )}
      <StyledInputContent text={text} count={count}>
        <StyledInput disabled={disabled} {...params} error={error} {...props} />
      </StyledInputContent>
      {error?.message ? (
        <ErrorLabelStyle>{error.message}</ErrorLabelStyle>
      ) : error ? (
        <ErrorLabelStyle>&nbsp;{t("GENERAL.MANDATORY_ROW")}</ErrorLabelStyle>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomInput;
